import { alpha, Theme } from '@mui/material';

export default {
    resultItems: {
        gap: '4px',
    },
    item: {
        border: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.16),
        borderRadius: '6px',
        padding: '6px 8px 8px 8px',
        gap: '4px',
    },
    iconHolder: {
        display: 'inline-flex',
    },
    link: {
        cursor: 'pointer',
        color: (theme: Theme) => theme.palette.primary.main,
        textDecoration: 'underline',
        fontWeight: '600',
        '&:hover': {
            textDecoration: 'none',
        },
    },
    description: {
        paddingLeft: '24px',
        '& p': {
            marginBlockStart: '0',
            marginBlockEnd: '0',
        },
    },
};
